import ServiceProviderModalContainer from './ServiceProviderModalContainer'

export default ServiceProviderModalContainer
